import React from 'react';
import Reveal from '../ui/Reveal';

const FeaturedWork = () => {
  const mediaLogos = [
    { name: 'CNBC Awaaz', type: 'text' },
    { name: 'Disha TV', type: 'text' },
    { name: 'TEDx', type: 'text' },
    { name: 'ACE Summit', type: 'text' },
    { name: 'Women Achievers', type: 'text' },
  ];

  const projects = [
    {
      title: "Global Tech Summit Launch",
      category: "Event PR",
      image: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=800&auto=format&fit=crop"
    },
    {
      title: "Executive Rebranding",
      category: "Personal Branding",
      image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?q=80&w=800&auto=format&fit=crop"
    },
    {
      title: "Sustainability Narrative",
      category: "Content Strategy",
      image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=800&auto=format&fit=crop"
    }
  ];

  return (
    <section id="work" className="py-24 bg-offwhite border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        
        {/* Media Mentions Strip */}
        <Reveal>
          <div className="mb-24">
            <p className="text-center text-sm uppercase tracking-widest text-gray-500 mb-8">Featured In & Trusted By</p>
            <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 opacity-70 grayscale">
              {mediaLogos.map((logo, i) => (
                <span key={i} className="font-serif text-xl md:text-2xl font-bold text-navy-800">
                  {logo.name}
                </span>
              ))}
            </div>
          </div>
        </Reveal>

        {/* Featured Work Grid */}
        <div className="flex flex-col md:flex-row justify-between items-end mb-12">
          <Reveal>
            <h2 className="font-serif text-4xl md:text-5xl text-navy-900">Featured Campaigns</h2>
          </Reveal>
          <Reveal delay={0.2}>
            <a href="#" className="hidden md:inline-block border-b border-navy-900 pb-1 text-sm uppercase tracking-widest hover:text-gold-600 hover:border-gold-600 transition-colors">
              View All Work
            </a>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <Reveal key={index} delay={index * 0.15}>
              <div className="group cursor-pointer">
                <div className="overflow-hidden relative h-[400px] mb-6">
                  <div className="absolute inset-0 bg-navy-900/20 group-hover:bg-transparent transition-colors duration-500 z-10"></div>
                  <img 
                    src={project.image} 
                    alt={project.title} 
                    className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700 ease-out"
                  />
                </div>
                <span className="text-gold-600 text-xs uppercase tracking-widest font-semibold block mb-2">
                  {project.category}
                </span>
                <h3 className="font-serif text-2xl text-navy-900 group-hover:text-gold-600 transition-colors duration-300">
                  {project.title}
                </h3>
              </div>
            </Reveal>
          ))}
        </div>

      </div>
    </section>
  );
};

export default FeaturedWork;